package com.essntl.uikit.components.chat.conversation.overviewcard

import com.essntl.uikit.components.chat.conversation.ConversationType
import com.essntl.uikit.components.chat.contact.ContactUiState
import com.essntl.uikit.components.chat.message.MessageUiState

data class ConversationOverviewUiState(
    val conversationId: String,
    val conversationType: ConversationType?,
    val contact: ContactUiState,
    val lastMessage: String,
    val isCurrentUserSender: Boolean,
    val unreadMessages: Int = 0,
    val dateTime: String,
    val lastMessageStatus: MessageUiState.Status?,
    val type: ChatType,
    val participants: List<String>?,
) {
    enum class ChatType {
        Contact,
        Group,
        Unknown,
    }
}